import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { noop } from 'lodash';

import BasicFormField from '../../../common/formFields/basicFormField';
import ShopArray from '../../../admin/users/components/Shared/shopArray';
import { USER_TYPES } from '../../../auth/constants';
import StaffPermissions from './permissions';
import CancelButtonLink from '../../../common/buttons/cancelButtonLink';
import DeleteButton from '../../../common/buttons/deleteButton';
import SaveButton from '../../../common/buttons/saveButton';
import { trimFunction } from '../../../common/trimData';

const StaffForm = ({
  shops,
  userKind,
  canModifyUsername,
  canModifyUserKind,
  canAssignShops,
  canModifyPermissions,
  canDelete,
  canSave,
  busy,
  onDelete,
  onCancel,
  handleSubmit,
  onSubmit,
  tmpPassword,
}) => (
  <div>
    <div className="c-inner-wrapper u-max-width-1000 u-mb-" display-if={!!tmpPassword}>
      Temporary password for this user is{' '}
      <strong data-automation-id="password">{tmpPassword}</strong>
    </div>
    <form className="c-inner-wrapper u-max-width-1000" onSubmit={handleSubmit(trimFunction(onSubmit))}>
      <fieldset disabled={busy}>
        <div className="c-heading c-heading--dark c-heading--main-header">
        Staff details
      </div>
        <div>
          <label className="c-radio u-mr-" htmlFor="kind5">
            <Field
              id="kind5"
              name="kind"
              component="input"
              type="radio"
              className="c-radio__input"
              value="5"
              disabled={!canModifyUserKind}
            />
            <span className="c-radio__trigger" />
            <span className="c-radio__label">Brand user</span>
          </label>
          <label className="c-radio u-mr-" htmlFor="kind2">
            <Field
              id="kind2"
              name="kind"
              component="input"
              type="radio"
              className="c-radio__input"
              value="2"
              disabled={!canModifyUserKind}
            />
            <span className="c-radio__trigger" />
            <span className="c-radio__label">Shop user</span>
          </label>
        </div>
        <BasicFormField
          placeholder="Username"
          label="Username"
          name="username"
          maxLength="50"
          wrapperClass="u-mt-"
          disabled={!canModifyUsername}
        />
        <div display-if={userKind === USER_TYPES.shop.toString()}>
          <div className="c-heading c-heading--dark c-heading--main-header u-mt-">
          Assign shops
        </div>
          <ShopArray
            shops={shops}
            showLabels
            canModify={canAssignShops}
          />
        </div>
        <div className="c-heading c-heading--dark c-heading--main-header u-mt-">
        Permissions
      </div>
        <fieldset disabled={!canModifyPermissions}>
          <StaffPermissions />
        </fieldset>
        <div className="c-separator u-mv" />
        <div className="layout">
          <div className="layout__item u-2/6">
            <DeleteButton
              className="c-btn c-btn--red u-width-120"
              display-if={canDelete}
              onClick={onDelete}
            />
          </div>
          <div className="layout__item u-4/6 u-text-right">
            <CancelButtonLink onClick={onCancel} content="Cancel" />
            <SaveButton
              content="Save"
              display-if={canSave}
            />
          </div>
        </div>
      </fieldset>
    </form>
  </div>
);

StaffForm.propTypes = {
  shops: PropTypes.array.isRequired,
  userKind: PropTypes.oneOf([USER_TYPES.shop.toString(), USER_TYPES.brand.toString()]).isRequired,
  canModifyUsername: PropTypes.bool.isRequired,
  canModifyUserKind: PropTypes.bool.isRequired,
  canAssignShops: PropTypes.bool.isRequired,
  canModifyPermissions: PropTypes.bool.isRequired,
  canDelete: PropTypes.bool.isRequired,
  canSave: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  busy: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  tmpPassword: PropTypes.string,
};

StaffForm.defaultProps = {
  onDelete: noop,
  tmpPassword: undefined,
};

export default StaffForm;
